import { modifier } from "ember-modifier"
import { later } from "@ember/runloop"

export default modifier(function autofocus(
  element: HTMLElement,
  [selector = "input:not([disabled])"]: any
) {
  const childElement = element.querySelector(selector)

  // We do a later so ember animated doesn't interfere
  // https://github.com/qonto/ember-autofocus-modifier/issues/88
  later(() => {
    if (childElement) {
      childElement.focus()
    } else {
      element.focus()
    }
  }, 200)
})
